import { FetchMappingGridStatusDisplayValue } from '../../../data/mappings';

const StatusComparator = (valueA, valueB) => {
    if (!valueA && !valueB) {
        return 0;
    }

    if (!valueA) {
        return -1;
    }

    if (!valueB) {
        return 1;
    }

    const compareValueA = FetchMappingGridStatusDisplayValue(valueA);
    const compareValueB = FetchMappingGridStatusDisplayValue(valueB);

    if (compareValueA > compareValueB) {
        return 1;
    }
    if (compareValueA < compareValueB) {
        return -1;
    }
    return 0;
};

export default StatusComparator;
